export default "__VITE_ASSET__CPRkhrj9__"